import { render, staticRenderFns } from "./PlyrWrapper.vue?vue&type=template&id=1a8a602e&"
import script from "./PlyrWrapper.vue?vue&type=script&lang=ts&"
export * from "./PlyrWrapper.vue?vue&type=script&lang=ts&"
import style0 from "./PlyrWrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports